import {
    handle,
    loader,
    shouldRevalidate,
    default as ProfessionalInfoRoute,
} from '~/routes/_app.professional.$urlSegment.info._index';

export { loader, handle, shouldRevalidate };
export default ProfessionalInfoRoute;
